import { faDesktop, faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import {
    HashRouter as Router,
    Route,
    Navigate,
    Routes,
    useNavigate,
} from "react-router-dom";
import Home from "./Home";
import Header from "./Header";
import ResetPassword from "./ResetPassword";
import Wrapper3D from "./3D";
import { browserHasAppInstallationId } from "../helpers/authorizationHelpers";
import { useEffect } from "react";
import StoryEditor from "./StoryEditor";

const App: React.FC = () => {

    return (
        <>
            <div className="p-0">
                <Router>
                    <Routes>
                        <Route path="/installed" element={<Navigate to="/installed/null/" />} />
                        <Route path="/installed/:installationId/">
                            <Route path="/installed/:installationId/" element={<Home />} />
                            <Route path="/installed/:installationId/play" element={<Wrapper3D />} />
                        </Route>
                        <Route path="/" element={<Intro />} />
                        <Route path="/resetpassword/:emailAddress/:code" element={<ResetPassword />} />
                        <Route path="/storyeditor" element={<StoryEditor />} />
                    </Routes>
                    <Header />
                </Router>
            </div>
        </>
    );
}

const Intro: React.FC = () => {
    const appIdSet = browserHasAppInstallationId()
    const navigate = useNavigate();

    useEffect(() => {
        if (appIdSet) {
            navigate(`/installed/null`)
        }
    });

    return (
        <div className="p-2">
            <Modal show={true} onHide={() => { }} >
                <Modal.Body>
                    <FontAwesomeIcon icon={faMobileScreen} className="me-2 text-orange" />
                    Install web app on your mobile device by adding it to your Home Screen.
                    <br />
                    <br />
                    <FontAwesomeIcon icon={faDesktop} className="me-2 text-orange" />
                    To use the app in browser, use <a target="_blank" href={`/#/installed/null/`} rel="noreferrer">this link</a>.
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default App;